/**
 * warmup.js — Pre-warm Vercel serverless function on app load
 * Fires a lightweight GET /v1/ping as soon as the React app mounts.
 * This way DB is connected before the user triggers a real API call.
 */
import API_CONFIG from '../config/api.config';

let warmed = false;

export function warmupServer() {
  if (API_CONFIG.MOCK || warmed) return;
  warmed = true;

  // Fire and forget — don't block rendering
  fetch(`${API_CONFIG.BASE_URL}/ping`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    signal: AbortSignal.timeout(8000),
  }).catch(() => {}); // silently ignore — this is just a warm-up
}
